/**
 * Get last slug without params
 *
 * @param url URL to get last slug without params
 *
 * @returns  URL last slug without params
 */
export function getLastSlugWithoutParams(url: string): string | undefined {
    if (!url) return undefined;
    try {
        const parsedUrl = new URL(url, 'http://example');
        return parsedUrl.pathname;
    } catch (error) {
        console.error('Invalid URL or pathname:', error);
        return url;
    }
}
